module.exports = "<div #mapContainer id=\"mapContainer\" style=\"height:340px;\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/hr/recruiting-map/recruiting-map/recruiting-map.component.html
// module id = ./src/app/web/game/management/business-units/hr/recruiting-map/recruiting-map/recruiting-map.component.html
// module chunks = main